const routes = {
  home: "/:id",
};

export default routes;

